export default "__VITE_ASSET__9512d98e__"